import {
  ELT_FORM_SECTION,
  IELTFormData,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useMemo } from 'react'

import { getFormedEltTranslation } from '../../helpers/getFormedEltTranslation'
import { SoldProductsNote } from '../styledComponents/notes/SoldProductsNote'
import { Title } from '../styledComponents/title/Title'

import { SoldProductTree } from './components/soldProductTree/SoldProductTree'
import { SoldPrintProducts } from './soldPrintProducts/SoldPrintProducts'
import { SoldPSProducts } from './soldPSProducts/SoldPSProducts'
import { SoldServicesProducts } from './soldServiceProducts/SoldServicesProducts'

import styles from './SoldProducts.module.scss'

interface IProps {
  formData: IELTFormData
  onChangeComplexFormData: (section: ELT_FORM_SECTION) => (data: TComplexSectionData) => void
}

export const SoldProducts = ({ formData, onChangeComplexFormData }: IProps) => {
  const soldProducts = useMemo(() => {
    return Object.entries(formData.SoldProductData || {}).map(([key, value]) => ({
      type: key,
      categories: value,
    }))
  }, [formData.SoldProductData])

  const isNewSoldProducts = useMemo(() => soldProducts.length > 0, [soldProducts])

  return (
    <div className={styles.root}>
      <Title
        noteContent={SoldProductsNote}
        text={getFormedEltTranslation('section-sold-products')}
        variant={'withBackground'}
      />

      <div className={styles.items}>
        {isNewSoldProducts &&
          soldProducts.map((item) => (
            <div className={styles.items__item} key={item.type}>
              <SoldProductTree
                onChangeComplexFormData={onChangeComplexFormData}
                products={formData.SoldProductData}
                type={item.type}
                categories={item.categories}
              />
            </div>
          ))}

        {!isNewSoldProducts && formData.SoldPSProducts && (
          <div className={styles.items__item}>
            <SoldPSProducts
              data={formData.SoldPSProducts}
              updateFormData={onChangeComplexFormData(ELT_FORM_SECTION.SOLD_PS_PRODUCTS)}
            />
          </div>
        )}

        {!isNewSoldProducts && formData.SoldPrintProducts && (
          <div className={styles.items__item}>
            <SoldPrintProducts
              data={formData.SoldPrintProducts}
              updateFormData={onChangeComplexFormData(ELT_FORM_SECTION.SOLD_PRINT_PRODUCTS)}
            />
          </div>
        )}

        {!isNewSoldProducts && formData.SoldServicesProducts && (
          <div className={styles.items__item}>
            <SoldServicesProducts
              data={formData.SoldServicesProducts}
              updateFormData={onChangeComplexFormData(ELT_FORM_SECTION.SOLD_SERVICES_PRODUCTS)}
            />
          </div>
        )}
      </div>
    </div>
  )
}
